import { TextSprite } from '../TextSprite';

/**
 * Create a label for displaying area measurements
 */
export function createAreaLabel(): TextSprite {
  const areaLabel = new TextSprite('');

  areaLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
  areaLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
  areaLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 0.3 });
  areaLabel.fontsize = 16;
  areaLabel.material.depthTest = false;
  areaLabel.material.opacity = 1;
  areaLabel.visible = false;

  return areaLabel;
}

/**
 * Create a label for displaying opening height measurements
 */
export function createHeightLabel(): TextSprite {
  const heightLabel = new TextSprite('');

  heightLabel.setTextColor({ r: 140, g: 200, b: 250, a: 1.0 });
  heightLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
  heightLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 0.3 });
  heightLabel.fontsize = 16;
  heightLabel.material.depthTest = false;
  heightLabel.material.opacity = 1;
  heightLabel.visible = false;

  return heightLabel;
}

/**
 * Create a label for displaying volume measurements
 */
export function createVolumeLabel(): TextSprite {
  const volumeLabel = new TextSprite('');

  volumeLabel.setTextColor({ r: 233, g: 140, b: 250, a: 1.0 });
  volumeLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
  volumeLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 0.3 });
  volumeLabel.fontsize = 16;
  volumeLabel.material.depthTest = false;
  volumeLabel.material.opacity = 1;
  volumeLabel.visible = false;

  return volumeLabel;
}
